import React, { useRef } from 'react';
import {
  Attachment,
  Avatar,
  messageHasReactions,
  MessageOptions,
  MessageStatus,
  MessageText,
  MessageTimestamp,
  ReactionSelector,
  SimpleReactionsList,
  closeReactionSelectorOnClick,
  useMessageContext,
} from 'stream-chat-react';

import './CustomMessage.css';
export const CustomMessage = () => {
  const {
    isReactionEnabled,
    message,
    reactionSelectorRef,
    showDetailedReactions,
  } = useMessageContext();

  const messageWrapperRef = useRef(null);

  const hasReactions = messageHasReactions(message);
  const hasAttachments = message.attachments && message.attachments.length > 0;

  return (
    
    <div className='message-wrapper'>
      <Avatar image={message.user?.image} />
      <div className='message-wrapper-content'>
        <div className='message-header'>
          <div className='message-header-name'>{message.user?.name}</div>
        </div>
        <MessageText />
        {hasAttachments && <Attachment attachments={message.attachments} />}
        {showDetailedReactions && isReactionEnabled &&  (
        <ReactionSelector ref={reactionSelectorRef} />
      )}
        <MessageStatus />
        <div className='reaction-wrapper'> 
          <MessageOptions messageWrapperRef={messageWrapperRef} />
          {hasReactions && <div className='divider-reaction'><p> | </p></div>}
        {hasReactions && <SimpleReactionsList />}
        </div>
      </div>
    </div>
  );
};
